import script from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./FilterDropdown.vue?vue&type=style&index=0&id=9ae86e78&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae86e78"]])

export default __exports__